// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ColumnOrderingDivider-base__aH9p8{display:flex;gap:var(--size-4);align-items:center;justify-content:center;padding:var(--size-0) var(--size-3)}.ColumnOrderingDivider-line__mi6To{flex:1}.ColumnOrderingDivider-label__Vi4cB{color:var(--text-placeholder);font:var(--font-caption-small-400);font-feature-settings:var(--feature-settings-caption-small-400);letter-spacing:var(--letter-spacing-caption-small-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ColumnOrderingDivider-base__aH9p8",
	"line": "ColumnOrderingDivider-line__mi6To",
	"label": "ColumnOrderingDivider-label__Vi4cB"
};
export default ___CSS_LOADER_EXPORT___;
